import React, { useEffect, useState, useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import '../index.scss'
import ReusableButton from '../../reusableComponents/button/customButton'
import DropDownMenu from '../../reusableComponents/dropDownMenu/DropDownMenu'
import SideDrawerMenu from '../../reusableComponents/sideDrawerMenu/sideDrawerMenu'
import HuntPlannerRightToolBar from '../huntPlanner-right-toolbar'
// import FilterComponent from '../moreFilterMenu'
import FilterComponent from '../moreFilterMenu/index'
import { fetchHuntPlannerLayers } from '../../../../action/huntplanner-state-Filter-actions'
// import { multiTileHuntLayers, removeZoomEVent } from '../../huntplanner-layer-render/renderlayerFunction'
import { removeLayers, multiTileHuntLayers, removeZoomEVent, multiTileHuntLayersXYZ } from '../../huntplanner-layer-render/renderlayerFunction'
import { huntPlannerFilterOptions } from '../../../../action/huntplanner-filterOptions-action'
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options'
import { formattedText } from '../../../../lib/util'
import { huntplannerMorefilters, closeMorefilterMenu, expandMorefilterMenu } from "../../../../action/huntplanner-morefilters-actions";
import { fetchGetFilterCount, fetchGetStateGetExtent, fetchGetFilterValues } from '../../../../action/huntPlanner-api-actions'
import { huntPlannerRightMenuBarexpand, huntPlannerRightMenuBarHide } from '../../../../action/huntplanner-menu-bar'
import { stopMapLoading, startMapLoading } from '../../../../action/huntplanner-map-loader'
import { huntPlannerRightMenuBarClose } from '../../../../action/huntplanner-menu-bar'
import { countNonEmptyKeysExcluding } from '../../reusableComponents/commonFunctions/commonFunctions'
import SelectedFilterOptions from '../moreFilterMenu/SelectedFilterOptions'
function debounce(func, delay) {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (typeof func === 'function') {
        func.apply(context, args);
      }
    }, delay);
  };
}
const TopMenuCoponent = (props) => {
  let [filterOptions, setFilterOptions] = useState({})
  let [selectedOptions, setSelectedOptions] = useState(['state'])
  let [activeSelection, setActiveSelection] = useState('state')
  let [selectedState, setSelectedState] = useState('')
  let [selectedSpecies, setSelectedSpecies] = useState('')
  let [selectedHuntTypes, setSelectedHuntTypes] = useState('')
  let [loadSideMenuBar, setLoadSideMenuBar] = useState(false)// make it false after testing
  let [loadFilterSideMenuBar, setLoadFilterSideMenuBar] = useState(false)
  let [apiStatesData, setApiStatesData] = useState(props.huntplannerStatesData)
  let [apiSpeciesData, setApiSpeciesData] = useState([])
  let [apiHuntTypesData, setApiHuntTypesData] = useState([])
  let [loadSpinner, setLoadSpinner] = useState(false)
  let [filterCount, setFilterCount] = useState({})
  let [filterData, setFilterData] = useState({})
  let [layersUrl, setLayerUrl] = useState('')
  let [fetchedOptions, setFetchedOptions] = useState({})
  let [filterValueOptionsData, setFilterValueOptionsData] = useState({})
  let [currentObj, setCurrentObj] = useState()
  const [countFilter, setCountFilter] = useState(0)
  let [moreFilterOptions, setMoreFilterOptions] = useState({})

  useEffect(() => {
    let { StateAbbreviation, Species, HuntTypeKey } = props.huntPlannerSelectedOtions
    if (StateAbbreviation && Species && HuntTypeKey) {
      let stateData = props.huntplannerStatesData.filter((item) => {
        if (item.stateAbbr == StateAbbreviation) {
          setSelectedState(item.stateName)
          setApiSpeciesData(item.species)
          return item
        }
      })

      let SpeciesData = apiSpeciesData.filter((item) => {
        if (item.name == Species) {
          setApiHuntTypesData(item.residency)
          return item
        }
      })

      setSelectedSpecies(Species)
      HuntTypeKey && setSelectedHuntTypes(formattedText(HuntTypeKey))
      setActiveSelection('')
      // setLoadSpinner(true)
      props.startMapLoading()

      const payload = {
        StateAbbreviation: StateAbbreviation,
        Species: Species,
        HuntTypeKey: HuntTypeKey,
        ...props.huntplannerMorefiltersState
      };
      setFilterOptions(props.huntPlannerSelectedOtions)
      props.fetchGetStateGetExtent(payload, StateAbbreviation)
        .then((res) => {
          fitMapToBounds(res)
          fetchFilterMenuValue(payload)
            .then((response) => {
              props.huntPlannerActiveOtions(payload)

              // ✅ Remove undefined, null, and empty string values
              Object.keys(payload).forEach((key) => {
                if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
                  delete payload[key];
                }
              });
              const params = new URLSearchParams(payload).toString();

              let layerRenderingApi = 'Layer/RenderHuntUnits'
              props.fetchGetFilterCount(payload)
                .then((res) => {
                  props.huntPlannerFilterOptions(response)
                  setFilterValueOptionsData(response);
                  setFilterCount(res)
                  props.startMapLoading()
                  setLoadSideMenuBar(true)
                  !props.huntplannerRightToolbarState && props.huntPlannerRightMenuBarexpand()
                  removeLayers(props.huntplannerMapReference)
                  setTimeout(() => {
                    if (res?.unitCount > 0) {
                      multiTileHuntLayers('', payload, { mapInstance: props.huntplannerMapReference, filters: [] }, true, layerRenderingApi, params, response, () => {
                        props.stopMapLoading()
                      })
                    } else {
                      removeZoomEVent(props.huntplannerMapReference)
                      props.huntMapLoader && props.stopMapLoading()
                    }
                  }, [1000 * 2]);
                })
                .catch((error) => {
                  props.huntMapLoader && props.stopMapLoading()
                  console.error('API Error:', error);
                });

              setMoreFilterOptions(payload)

            })
            .catch((error) => {
              console.error('Failed to fetch filter values:', error);
            });

        })
        .catch((error) => {
          console.error('API Error:', error);
        });
    }
  }, [props.huntplannerMapReference])

  const debouncedhandleFilterFetch = debounce(handleFilterFetch, 1000);

  // Debounce function
  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  // Use useCallback to memoize the debounced function
  const debouncedOnChangeOptions = useCallback(
    debounce(handleFilterFetch, 1000),
    [] // Empty dependency array to keep the debounce function stable
  );

  useEffect(() => {
    if (props.huntplannerMorefiltersState) {
      const excludeKeys = ["StateAbbreviation", "Species", "HuntTypeKey", "unitName", "DrawChoice"];
      const count = countNonEmptyKeysExcluding(props.huntplannerMorefiltersState, excludeKeys);
      setCountFilter(count)

      if (props.huntplannerMorefiltersState?.HuntTypeKey && props.huntplannerMorefiltersState?.Species && props.huntplannerMorefiltersState?.StateAbbreviation) {
        handleFilterFetch(props.huntplannerMorefiltersState, currentObj, false);
      }
    }
  }, [props.huntplannerMorefiltersState])



  let handleClick = (e) => {
    const name = e.target.name;
    if (name == 'state') {
      setSelectedHuntTypes('')
      setSelectedSpecies('')
      setFilterOptions({})
      setLoadSideMenuBar(false)
      props.huntplannerRightToolbarState && props.huntPlannerRightMenuBarHide()
      setLoadFilterSideMenuBar(false)
      props.expandMorefilterMenu(false)
    }

    if (activeSelection == name && activeSelection != 'state') {
      setActiveSelection('')
    } else {
      setActiveSelection(name)
    }
  }

  let onSelectState = (value, nextSelection, object, speciesObject) => {

    props.huntPlannerRightMenuBarClose()
    props.huntPlannerFilterOptions([])
    props.startMapLoading()
    removeLayers(props.huntplannerMapReference)
    object && setCurrentObj(object)
    if (!selectedOptions.includes(nextSelection)) {
      nextSelection && setActiveSelection(nextSelection)
      setSelectedState(value)
      speciesObject && setApiSpeciesData(speciesObject.returnSpaciesObject)

      const payload = {
        stateAbbr: object.stateAbbr,
      };
      props.huntplannerMorefilters([])
      props.fetchGetStateGetExtent(payload, payload.stateAbbr)
        .then((res) => {
          fitMapToBounds(res)
          setTimeout(() => {
            multiTileHuntLayers(object, payload.stateAbbr, { mapInstance: props.huntplannerMapReference, filters: [] }, true, false, payload, object, () => {
            })
          }, [2000])
        })
        .catch((error) => {
          console.error('API Error:', error);
        });
    }

    // Update selectedOptions with the state selection
    setFilterOptions((prevState) => ({
      ...prevState,
      StateAbbreviation: object.stateAbbr,
    }));
  }

  let onSelectSpecies = (value, nextSelection, object, huntTypesOptions) => {
    if (!selectedOptions.includes(nextSelection)) {
      setApiHuntTypesData(huntTypesOptions.huntTypes)
      setActiveSelection(nextSelection)
      setSelectedSpecies(value)
      setFilterOptions((prevState) => ({
        ...prevState,
        Species: object.name,
      }));
    }
    props.huntplannerMorefilters([])
  }

  let onSelectHuntTypes = (value, nextSelection, object, obj) => {
    props.startMapLoading()
    removeLayers(props.huntplannerMapReference)
    props.huntplannerMorefilters([])
    props.huntPlannerActiveOtions([])
    if (!selectedOptions.includes(nextSelection)) {
      setActiveSelection(nextSelection)
      setSelectedHuntTypes(value)

      // Update filterOptions with the hunt type selection
      setFilterOptions((prevState) => {
        const updatedFilterOptions = {
          ...prevState,
          HuntTypeKey: object.key,
        };

        // After the state is updated, fetch data
        const payload = {
          StateAbbreviation: updatedFilterOptions.StateAbbreviation,
          Species: updatedFilterOptions.Species,
          HuntTypeKey: updatedFilterOptions.HuntTypeKey,
        };

        console.log(updatedFilterOptions, '======================================>updatedFilterOptions')

        handleFilterFetch(payload, currentObj, true, true);
        setFetchedOptions(payload)
        return updatedFilterOptions; // Return the updated state
      });
    }
  }

  const fitMapToBounds = (response) => {
    if (!props.huntplannerMapReference) {
      console.error("Map reference is not available");
      return;
    }

    const map = props.huntplannerMapReference;

    if (!response?.upperLeft || !response?.lowerRight) {
      console.error("Invalid bounds data");
      return;
    }

    // Create a new bounds object
    const bounds = new google.maps.LatLngBounds();

    // Extract bounds from response
    const { upperLeft, lowerRight } = response;

    // Add the upper-left and lower-right coordinates to the bounds
    bounds.extend(new google.maps.LatLng(upperLeft.latitude, upperLeft.longitude));
    bounds.extend(new google.maps.LatLng(lowerRight.latitude, lowerRight.longitude));

    // Fit the map to the defined bounds
    map.fitBounds(bounds);
    // map.setZoom()
  };

  const handleFilterFetch = (payloadData, object, makeFilterCall, initialCall) => {
    let payload = {
      StateAbbreviation: payloadData.StateAbbreviation,
      Species: payloadData.Species,
      HuntTypeKey: payloadData.HuntTypeKey,

      method: payloadData.method,
      season: payloadData.season,
      sex: payloadData.sex,
      harvestSuccess: payloadData.harvestSuccess,
      trophyPotential: payloadData.trophyPotential,
      publicLand: payloadData.publicLand,

      DrawPoints: payloadData.DrawPoints,
      DrawPercentage: payloadData.DrawPercentage,
      DrawChoice: payloadData.DrawChoice ? payloadData.DrawChoice : !payloadData.Choice ? props.huntPlannerFilterOptionsState?.drawOdds?.drawChoices[0] : '',
      Choice: payloadData.Choice,
      ExactPoints: payloadData.ExactPoints,
    };

    // if (makeFilterCall) {
    fetchFilterMenuValue(payloadData)
      .then((response) => {
        if (initialCall) {
          props.huntplannerMorefilters({ DrawChoice: response?.drawOdds?.drawChoices[0] })
          props.huntPlannerActiveOtions({ ...payload, DrawChoice: response?.drawOdds?.drawChoices[0] })
        } else {
          props.huntPlannerActiveOtions(payload)
        }
        props.huntPlannerFilterOptions(response)
        setFilterValueOptionsData(response);
        // ✅ Remove undefined, null, and empty string values
        Object.keys({ ...payload, DrawChoice: response?.drawOdds?.drawChoices[0] }).forEach((key) => {
          if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key];
          }
        });

        const params = new URLSearchParams(payload).toString();

        let layerRenderingApi = 'Layer/RenderHuntUnits'

        props.fetchGetFilterCount(payload)
          .then((res) => {
            setFilterCount(res)
            props.startMapLoading()
            setLoadSideMenuBar(true)
            !props.huntplannerRightToolbarState && props.huntPlannerRightMenuBarexpand()
            // removeLayers(props.huntplannerMapReference)
            setTimeout(() => {
              if (res?.unitCount > 0) {
                multiTileHuntLayers(object, payload, { mapInstance: props.huntplannerMapReference, filters: [] }, true, layerRenderingApi, params, response, () => {
                })
              } else {
                removeLayers(props.huntplannerMapReference)
                removeZoomEVent(props.huntplannerMapReference)
                props.stopMapLoading()
              }
            }, [1000 * 2]);
          })
          .catch((error) => {
            props.huntMapLoader && props.stopMapLoading()
            console.error('API Error:', error);
          });


      })
    // } else {
    //   // fetchFilterMenuValue(payloadData)
    //   //   .then((response) => {
    //   props.huntPlannerActiveOtions(payload)
    //   // ✅ Remove undefined, null, and empty string values
    //   Object.keys(payload).forEach((key) => {
    //     if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
    //       delete payload[key];
    //     }
    //   });

    //   const params = new URLSearchParams(payload).toString();

    //   let layerRenderingApi = 'Layer/RenderHuntUnits'

    //   props.fetchGetFilterCount(payload)
    //     .then((res) => {
    //       setFilterCount(res)
    //       props.startMapLoading()
    //       setLoadSideMenuBar(true)
    //       !props.huntplannerRightToolbarState && props.huntPlannerRightMenuBarexpand()
    //       // removeLayers(props.huntplannerMapReference)
    //       setTimeout(() => {
    //         if (res?.unitCount > 0) {
    //           multiTileHuntLayers(object, payload, { mapInstance: props.huntplannerMapReference, filters: [] }, true, layerRenderingApi, params, props.huntPlannerFilterOptions, () => {
    //           })
    //         } else {
    //           removeZoomEVent(props.huntplannerMapReference)
    //           props.stopMapLoading()
    //         }
    //       }, [1000 * 2]);
    //     })
    //     .catch((error) => {
    //       props.huntMapLoader && props.stopMapLoading()
    //       console.error('API Error:', error);
    //     });
    // }



    setMoreFilterOptions(payload)

    // })
    // .catch((error) => {
    //   console.error('Failed to fetch filter values:', error);
    // });
  }

  let fetchFilterMenuValue = (payloadData) => {
    return new Promise((resolve, reject) => {
      let payload = {
        StateAbbreviation: payloadData.StateAbbreviation,
        Species: payloadData.Species,
        HuntTypeKey: payloadData.HuntTypeKey,
      };
      props.huntPlannerActiveOtions(payload);

      props.fetchGetFilterValues(payload)
        .then((res) => {
          resolve(res); // Resolve the promise with response data
        })
        .catch((error) => {
          console.error('API Error:', error);
          reject(error); // Reject the promise with error
        });
    });
  };


  useEffect(() => {
    if (props.huntPlannerUnitRightMenuBar?.expanded) {
      setLoadFilterSideMenuBar(false)
      props.expandMorefilterMenu(false)
    }
  }, [props.huntPlannerUnitRightMenuBar])


  let handleMoreFilters = () => {
    setLoadFilterSideMenuBar(!loadFilterSideMenuBar)

    if (loadFilterSideMenuBar) {
      props.expandMorefilterMenu(false)
    } else {
      props.expandMorefilterMenu(true)
    }
  }

  let handleClickXYZ = () => {
    multiTileHuntLayersXYZ(props.huntplannerMapReference)
  }

  return (
    <>
      {(selectedState == '' || selectedSpecies == '' || selectedHuntTypes == '') && <div className='blur-background'></div>}
      <div className='hunt-planner-top-menu'
        style={{
          position: 'relative',
          right: (loadSideMenuBar && !props.huntplannerMorefiltersExpand ? '13%' : props.huntplannerMorefiltersExpand ? '20%' : '')//27%
          // right: (props.huntplannerMorefiltersExpand ? '10%' : loadSideMenuBar ? '12%' : '')
        }}
      >
        <div className="button-container-style">
          <ReusableButton
            buttonName="state"
            className="lets-go-button-label"
            label={selectedState ? selectedState : "State"}
            onClick={handleClick}
            variant="primary"
            size="small"
            buttonWidth="200px"
            buttonHeight="38px"
            buttonColor={activeSelection == 'state' ? "#589500" : ''}
            borderColor={activeSelection == 'state' ? '' : '#589500'}
          />
          {activeSelection == 'state' &&
            <div className="dropdown-wrapper">
              <DropDownMenu
                DropDownName={"state"}
                // currentObj={currentObj}
                dropStateOptions={apiStatesData}
                onSelect={onSelectState} nextSelection='species' />
            </div>}
        </div>

        <div className="button-container-style">
          <ReusableButton
            buttonName='species'
            className='lets-go-button-label'
            disabled={activeSelection == "state"}
            label={selectedSpecies ? selectedSpecies : "Species"}
            onClick={handleClick}
            variant="primary"
            size="small"
            buttonWidth='200px'
            buttonHeight="38px"
            buttonColor={activeSelection == 'species' ? "#589500" : ''}
            borderColor={activeSelection == 'species' ? '' : '#589500'}

          />
          {activeSelection == 'species' &&
            <div className="dropdown-wrapper">
              <DropDownMenu DropDownName={"species"} dropDownOptions={apiSpeciesData} onSelect={onSelectSpecies} nextSelection='huntTypes' />
            </div>
          }
        </div>

        <div className="button-container-style">
          <ReusableButton
            buttonName='huntTypes'
            disabled={(activeSelection == "state") || (activeSelection == "species")}
            className='lets-go-button-label'
            label={selectedHuntTypes ? selectedHuntTypes : "huntTypes"}
            onClick={handleClick}
            variant="primary"
            size="small"
            buttonWidth='200px'
            buttonHeight="38px"
            buttonColor={activeSelection == 'huntTypes' ? "#589500" : ''}
            borderColor={activeSelection == 'huntTypes' ? '' : '#589500'}
          />
          {activeSelection == 'huntTypes' &&
            <div className="dropdown-wrapper">
              <DropDownMenu DropDownName={"huntTypes"} dropDownOptions={apiHuntTypesData} onSelect={onSelectHuntTypes} nextSelection={'moreFilters'} />
            </div>
          }
        </div>

        <div className="button-container-style" style={{ width: 200 }}>
          {
            (activeSelection == 'moreFilters')
              ?
              <ReusableButton
                buttonName='moreFilters'
                className='lets-go-button-label'
                // label={loadFilterSideMenuBar ? "Hide..." : "More Filters"}
                label={loadFilterSideMenuBar ? `Hide Filters (${countFilter})` : `${countFilter == 0 ? 'More Filters...' : `More Filters (${countFilter})`}`}
                onClick={handleMoreFilters}
                disabled={props.huntPlannerUnitRightMenuBar?.expanded}
                variant="primary"
                size="small"
                buttonWidth='200px'
                buttonHeight="38px"
                borderColor={props.huntPlannerUnitRightMenuBar?.expanded ? '#535151' : '#589500'}
              />
              :
              selectedState && selectedSpecies && selectedHuntTypes ?
                <ReusableButton
                  buttonName='moreFilters'
                  className='lets-go-button-label '
                  label={loadFilterSideMenuBar ? `Hide Filters (${countFilter})` : `${countFilter == 0 ? 'More Filters...' : `More Filters (${countFilter})`}`}
                  onClick={handleMoreFilters}
                  variant="primary"
                  disabled={props.huntPlannerUnitRightMenuBar?.expanded}
                  size="small"
                  buttonWidth='200px'
                  buttonHeight="38px"
                  borderColor={props.huntPlannerUnitRightMenuBar?.expanded ? '#535151' : '#589500'}
                  color={props.huntPlannerUnitRightMenuBar?.expanded ? '#535151' : ''}
                />
                :
                <></>
          }
        </div>

        {/* {true &&
          <div className="button-container-style">
            <ReusableButton
              buttonName='Hello'
              className='lets-go-button-label'
              label={'XYZ Layer'}
              onClick={handleClickXYZ}
              variant="primary"
              size="small"
              buttonWidth='200px'
              buttonHeight="38px"
              buttonColor={activeSelection == 'species' ? "#589500" : ''}
              borderColor={activeSelection == 'species' ? '' : '#589500'}
            />
          </div>
        } */}

        {/* Root for Right side tool bar */}

        {/* {loadSideMenuBar && */}
        {props.huntplannerRightToolbarState &&
          <SideDrawerMenu handleClose={() => {
            setLoadSideMenuBar(false);
            props.huntPlannerRightMenuBarexpand()
          }}>
            <HuntPlannerRightToolBar
              filterCount={filterCount}
              payloadObject={moreFilterOptions}
              moreFilterOptions={moreFilterOptions}
            />
          </SideDrawerMenu>}

        {/*Root for Filter menu */}
        {loadFilterSideMenuBar &&
          <SideDrawerMenu right={true} handleClose={() => {
            setLoadFilterSideMenuBar(!loadFilterSideMenuBar);
            props.expandMorefilterMenu(false)
          }}>
            <FilterComponent
              filterPayload={fetchedOptions}
              handleFilterFetch={handleFilterFetch}
              currentObj={currentObj}
              filterValue={filterValueOptionsData}
              filterData={filterData}

            ></FilterComponent>
          </SideDrawerMenu >}

        <SelectedFilterOptions></SelectedFilterOptions>

      </div >
    </>
  )
}

const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  auth: state.auth,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntplannerMorefiltersState: state.huntplannerMorefilters,
  huntplannerRightToolbarState: state.huntplannerRightToolbar,
  huntplannerMorefiltersExpand: state.huntplannerMorefiltersExpand,
  huntplannerActiveLayersDetails: state.huntplannerActiveLayersDetails,
  huntMapLoader: state.huntMapLoader,
  huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
  huntPlannerFilterOptionsState: state.huntPlannerFilterOptions
})

const mapDispatchToProps = dispatch => ({
  fetchHuntPlannerLayers: (cb) => dispatch(fetchHuntPlannerLayers(cb)),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload)),
  huntPlannerFilterOptions: (payload) => dispatch(huntPlannerFilterOptions(payload)),
  huntplannerMorefilters: (payload) => dispatch(huntplannerMorefilters(payload)),
  fetchGetFilterCount: (payload) => dispatch(fetchGetFilterCount(payload)),
  fetchGetStateGetExtent: (payload, state) => dispatch(fetchGetStateGetExtent(payload, state)),
  fetchGetFilterValues: (payload) => dispatch(fetchGetFilterValues(payload)),
  expandMorefilterMenu: (payload) => dispatch(expandMorefilterMenu(payload)),
  closeMorefilterMenu: () => dispatch(closeMorefilterMenu()),
  startMapLoading: () => dispatch(startMapLoading()),
  stopMapLoading: () => dispatch(stopMapLoading()),
  huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose()),
  huntPlannerRightMenuBarexpand: (payload) => dispatch(huntPlannerRightMenuBarexpand(payload)),
  huntPlannerRightMenuBarHide: () => dispatch(huntPlannerRightMenuBarHide())
})

export default connect(mapStateToProps, mapDispatchToProps)(TopMenuCoponent)